import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import AssignAgentSettingsForm from './AssignAgentSettingsForm';
import i18n from 'i18n';

interface AssignAgentSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeAgentId: number;
    activeTeamId: number;
    activeAgentTeamId: number;
}

const AssignAgentSettingsModal: React.FC<AssignAgentSettingsModalProps> = React.memo((
    {
        modalOpen,
        closeModal,
        activeAgentId,
        activeTeamId,
        activeAgentTeamId
    },
) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_agent_team.text')}
        entityId={activeAgentTeamId}
        entityIdPropName="agentTeamId"
        FormComponent={AssignAgentSettingsForm}
        formProps={{
            agentId: activeAgentId,
            teamId: activeTeamId
        }}
    />
));

AssignAgentSettingsModal.displayName = 'AssignAgentSettingsModal';

export default AssignAgentSettingsModal; 